import wixWidget from 'wix-widget';

/**
 * @function
 * @description Controls the visibility and state of a Wix element.
 * @param {string} elementId - The ID of the Wix element.
 * @param {string} visibilityStatus - The desired visibility status ('show', 'hide', 'scroll', 'disable', 'enable').
 * @returns nothing 
 */
export async function controllElementVisibility(elementId, visibilityStatus) {
    try {
        if (Array.isArray(elementId)) {
            for (const id of elementId) {
                await applyVisibility(id, visibilityStatus);
            }
        } else {
            await applyVisibility(elementId, visibilityStatus);
        }
    } catch (error) {
        console.error("Error controlling element visibility:", error);
    }
}

export async function applyVisibility(elementId, visibilityStatus) {

    try {
        switch (visibilityStatus) {
        case 'show':
            await $w(elementId).show();
            await $w(elementId).expand();
            break;
        case 'hide':
            await $w(elementId).hide();
            await $w(elementId).collapse();
            break;
        case 'scroll':
            await $w(elementId).scrollTo();
            break;
        case 'disable':
            await $w(elementId).disable();
            break;
        case 'enable':
            await $w(elementId).enable();
            break;
        default:
            await $w(elementId).show();
            await $w(elementId).expand();
            break;
        }
    } catch (error) {
        console.error("Error applying visibility:", error);
    }
}

export function setSupportLinks(instanceId, reviewUrl) {

    $w('#mainBtnOpenTabSupport').link = `https://feedback.marketpushapps.com/?instance=f4a75e26-f113-4bb9-898e-60fef2418182&app=payment_methods&page=support`;
    $w("#mainBtnOpenTabSupport").target = "_blank";
    $w('#mainBtnOpenTabReview').link = `https://feedback.marketpushapps.com/?instance=f4a75e26-f113-4bb9-898e-60fef2418182&app=payment_methods&page=feedback-mood#/feedback/select-mood`;
    $w("#mainBtnOpenTabReview").target = "_blank";

    $w('#mainBtnMoreMkpApps').link = 'https://www.wix.com/app-market/developer/marketpushapps';
}